import {MaterialTechnology} from '../../../commons/src/types'

import {OrderStatusType} from '../order-types'

export default {
  sentry: {
    enabled: false,
    dsn: 'https://ea95c35516cc4d8692f528c92a0ef53c@o88782.ingest.sentry.io/5668265',
    release: process.env.SENTRY_RELEASE_VERSION || '',
    environment: 'development',
  },
  amplify: {
    Auth: {
      Cognito: {
        userPoolId: 'eu-west-1_ywoyn8p2d',
        userPoolClientId: '348otdktmbv42dkeqcujnj4hva',
      },
    },
  },
  dixa: {
    enabled: true,
    setDefaultUser: false,
    formEndpoint: 'https://forms.dixa.io/v2/forms/2BO9kS65elS2PbUg0sfrwD/3dY8D5GZtelVL2pi4SZJgk',
  },
  elevio: {
    enabled: true,
    accountId: '615ef753881da',
    dixaChatModuleId: 4,
    hiddenModuleIds: [1, 8, 10, 11, 13, 14, 15],
    settings: {
      hideLauncher: true,
      display_type: 'full',
    },
    language: 'en',
  },
  services: {
    api: {
      baseUrl: 'https://catalog-stg.craftcloud3d.com',
    },
    partner: {
      baseUrl: 'https://partner-api-stg.craftcloud3d.com',
    },
    craftcloud: {
      baseUrl: 'https://stage.craftcloud3d.com',
    },
    internal: {
      baseUrl: 'https://internal-api-stg.craftcloud3d.com',
    },
  },
  emails: {
    partner: 'partners@craftcloud3d.com',
  },
  cloudinaryUrl: '//res.cloudinary.com/all3dp/image/upload',
  cloudinaryDefaultParams: ['q_90', 'f_auto'],
  currencies: [
    {value: 'USD', label: 'USD', symbol: 'US$', formatter: (price: string) => `US$ ${price}`},
    {value: 'EUR', label: 'EUR', symbol: '€', formatter: (price: string) => `${price} €`},
    {value: 'GBP', label: 'GBP', symbol: '£', formatter: (price: string) => `£ ${price}`},
    {value: 'CAD', label: 'CAD', symbol: 'CA$', formatter: (price: string) => `CA$ ${price}`},
    {value: 'AUD', label: 'AUD', symbol: 'AU$', formatter: (price: string) => `AU$ ${price}`},
  ],
  cancellationReasonCategories: [
    {
      label: 'After sales',
      key: 'afterSales',
      visibleFor: ['received'],
    },
    {
      label: 'Pre production',
      key: 'preProduction',
      visibleFor: ['ordered', 'in_production', 'blocked'],
    },
    {
      label: 'Delays',
      key: 'delays',
      visibleFor: ['ordered', 'in_production', 'shipped', 'received', 'blocked'],
    },
    {
      label: 'Shipping',
      key: 'shipping',
      visibleFor: ['shipped', 'received'],
    },
    {
      label: 'Customer',
      key: 'customer',
      visibleFor: ['ordered', 'in_production', 'blocked'],
    },
  ],
  cancellationReasonOptionsMap: {
    afterSales: [
      {
        label: 'Order damaged',
        value: 'R1.1_order-damaged',
      },
      {
        label: 'Order warped',
        value: 'R1.2_order-warped',
      },
      {
        label: 'Wrong quantity',
        value: 'R1.3_wrong_quantity',
      },
      {
        label: 'Wrong material or color',
        value: 'R1.4_wrong-material-or-color',
      },
      {
        label: 'General quality issues',
        value: 'R1.5_general-quality-issues',
      },
      {
        label: 'Tolerances off',
        value: 'R1.6_tolerances-off',
      },
    ],
    preProduction: [
      {
        label: 'Broken files',
        value: 'R2.1.1_broken-files-mesh-errors',
      },
      {
        label: 'Wall thickness issues',
        value: 'R2.1.2_wall-thickness-detail-issues',
      },
      {
        label: 'Multi shell files',
        value: 'R2.1.3_multi-shell-files-multi-objects',
      },
      {
        label: 'Design not suitable for technology',
        value: 'R2.2_design-not-suitable-for-technology',
      },
      {
        label: 'Design not suitable for material',
        value: 'R2.3_design-not-suitable-for-material',
      },
      {
        label: 'Material not in stock',
        value: 'R2.5.1_material-not-in-stock',
      },
      {
        label: 'Prices not accurate',
        value: 'R2.5.2_prices-not-accurate',
      },
      {
        label: 'Optimal orientation impossible',
        value: 'R7.4_optimal-orientation-impossible',
      },
      {
        label: 'Inappropriate model',
        value: 'R7.5_inappropriate_model',
      },
    ],
    delays: [
      {
        label: 'Lead time too long',
        value: 'R3_lead-time-too-long',
      },
      {
        label: 'Delay due to long print time',
        value: 'R3.1_delay-due-to-long-print-time',
      },
      {
        label: 'Delay due to machine failure',
        value: 'R3.2_delay-due-to-machine-failure',
      },
      {
        label: 'Combining 2 orders',
        value: 'R7.1_combining-2-orders',
      },
    ],
    shipping: [
      {
        label: 'Delayed shipment',
        value: 'R3.3_delayed-shipment',
      },
      {
        label: 'Lost shipment',
        value: 'R3.4_lost-shipment',
      },
    ],
    customer: [
      {
        label: 'Changes in configuration or quantity',
        value: 'R4_changes-in-configuration-or-quantity',
      },
      {
        label: 'Customer unresponsive',
        value: 'R7.2_customer-unresponsive',
      },
    ],
  },
  fileSizeLimit: 524288000, // Bytes (500MB)
  defaultStatusFilters: [
    OrderStatusType.ORDERED,
    OrderStatusType.IN_PRODUCTION,
    OrderStatusType.SHIPPED,
  ],
  technologyFilterMap: {
    [MaterialTechnology.THREE_D_PRINTING]: {
      label: '3D Printing',
    },
    [MaterialTechnology.CNC_MACHINING]: {
      label: 'CNC Machining',
    },
  },
  providerEmail: {
    invoiceDescription:
      'If checked, the entered email will receive the monthly list of orders that can be invoiced in that month.',
    ordersDescription:
      'If checked, the entered email will receive email confirmations of all orders that are placed.',
    messagesDescription:
      'If checked, the entered email will receive incoming messages when customers need to establish contact with you regarding their order.',
    newsDescription: 'If checked, the entered email will receive our newsletters.',
  },
  orderMessageMaxLength: 5000, // chars
  orderMessageAttachmentMaxCount: 10,
  orderMessageReadTimeout: 3000, // 3s
  dateRangeConfig: {
    creationDate: {
      earliestFromTodayDays: 365,
      maxDaysRange: 90,
      defaultFromDays: 30,
      defaultToDays: 0,
    },
    invoices: {
      earliestFromTodayDays: 365,
      maxDaysRange: 90,
      defaultFromDays: 30, // not used for invoices
      defaultToDays: 0, // not used for invoices
    },
  },
  additionalCost: {
    descriptionMaxLength: 150, // chars
  },
  refund: {
    enabled: true,
    descriptionMaxLength: 150, // chars
    descriptionMinLength: 3, // chars
  },
  localStorageKeys: {
    orderExpandedIds: 'orders_expandedIds',
    ordersFilterValues: 'orders_filterValues',
    providerInfoExpandedIds: 'providerInfo_expandedIds',
    defaultStatusFilters: 'default_order_status_filters',
  },
  askForReview: {
    maxDaysOld: 180,
    minDaysOld: 7,
  },
  priceCalculation: {
    pricePremiumShare: 0.3, // 30%
    craftcloudMargin: 0.25, // 25%
    profitShare: 0.3, // 30%
    modelFee: {
      USD: 1.2,
      EUR: 1.15,
      GBP: 0.95,
      CAD: 1.7,
      AUD: 1.9,
    },
  },
  dynamicProductionTimes: {
    maxIncrease: 50,
    maxIncreaseSteps: 50,
  },
  providerDescription: {
    minLength: 200,
    maxLength: 750,
  },
  profileImagesMaxCount: 5,
  industryCategoryMap: {
    aviation: 'Aviation',
    aerospace: 'Aerospace',
    automotive: 'Automotive',
    biotechnology: 'Biotechnology',
    chemicals: 'Chemicals',
    construction_and_engineering: 'Construction & Engineering',
    consumer_goods: 'Consumer Goods',
    electronic_equipment: 'Electronic Equipment',
    healthcare: 'Health Care',
    household_durables: 'Household Durables',
    industrial_goods: 'Industrial Goods',
    machinery_and_equipment: 'Machinery and Equipment',
    marine: 'Marine',
    other: 'Other',
  },
  ccMarginOnAdditionalCostExceptions: ['Import Duties Prepayment'],
}
